/**
 * 系统设置
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 系统设置 -->
    <el-tabs type="border-card" style="margin-top: 20px;">
      <el-tab-pane label="基础设置">
        <el-form>
          <el-form-item label="公众号启用/停用">
            <el-switch v-model="wechat_status" active-value="on" inactive-value="off" @change="wxbar"></el-switch>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="参数配置">
        <el-table
          v-loading="loading"
          :data="optionData"
          style="width: 100%;margin-bottom: 20px;"
          row-key="id"
          border
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
          <el-table-column label="序号" type="index" align="center" width="80"></el-table-column>
          <el-table-column prop="title" label="名称" align="center" width="200"></el-table-column>
          <el-table-column prop="num" label="编码" align="center" width="200"></el-table-column>
          <el-table-column prop="val" label="数值"></el-table-column>
          <el-table-column prop="sort" label="操作" align="center" width="100">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" @click="editoptin(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </el-tab-pane>
      <el-tab-pane label="修改退费密码">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
          <el-form-item label="旧 密 码" prop="oldpasswd" style="width: 200px;">
            <el-input v-model="ruleForm.oldpasswd" autocomplete="off" type="password" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="新 密 码" prop="newpasswd">
            <el-input v-model="ruleForm.newpasswd" autocomplete="off" type="password" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="repasswd">
            <el-input v-model="ruleForm.repasswd" autocomplete="off" type="password" style="width: 200px;"></el-input>
          </el-form-item>
          <el-button size="mini" type="primary" @click="submitpsw('ruleForm')" style="margin-left: 240px;">确 定</el-button>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <!-- 参数设置 -->
    <el-dialog title="参数设置" :visible.sync="optionVisible">
      <el-form :model="form">
        <el-input type="input" v-model="form.value"></el-input>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitform">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { sysParam,wxStart,optionList,setOption,editRefundPsw } from '../../api/baseset'
  import Pagination from '../../components/Pagination'
  export default {
    data() {
      var validator = (rule, val, callback) =>{
        if(val == ''){callback(new Error('请输入旧密码'))}
        if(val.length < 6 || val.length > 12){callback(new Error('密码长度位6-12位'))}
        callback();
      }
      var validator1 = (rule, val, callback) =>{
        if(val == ''){callback(new Error('请输入新密码'))}
        if(val.length < 6 || val.length > 12){callback(new Error('密码长度位6-12位'))}
        callback();
      }
      var validator2 = (rule, val, callback) =>{
        if(val == ''){callback(new Error('请输入确认密码'))}
        if(val !== this.ruleForm.newpasswd){callback(new Error('输入的密码不一致'))}
        callback();
      }
      return {
        loading: false,
        wechat_status: 'on',
        optionData: [],
        optionVisible: false,
        form: {
          id: 0,
          value: ''
        },
        formInline: {
          page: 1,
          limit: 10
        },
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        ruleForm: {
          oldpasswd: '',
          newpasswd: '',
          repasswd: ''
        },
        rules: {
          oldpasswd: [{ validator: validator, trigger: 'blur' }],
          newpasswd: [{ validator: validator1, trigger: 'blur' }],
          repasswd: [{ validator: validator2, trigger: 'blur' }]
        }
      }
    },
    created() {
      this.getdata();
      this.getoption(this.formInline);
    },
    components: {
      Pagination
    },
    methods:{
      getdata() {
        sysParam().then(res => {
          this.wechat_status = res.data.wechat_status
        })
      },
      getoption(param) {
        this.loading = true
        optionList(param).then(res => {
          this.loading = false
          this.optionData = res.data
          // 分页赋值
          this.pageparm.currentPage = this.formInline.page
          this.pageparm.pageSize = this.formInline.limit
          this.pageparm.total = res.count
        })
      },
      wxbar() {
        this.$confirm('您确定要关闭微信吗?', '信息', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const data = {status: this.wechat_status}
          wxStart(data).then(res => {
            if(res.code == 0){
              this.$message({
                type:'success',
                message: res.msg
              })
            }else{
              this.wechat_status = this.wechat_status === 'on'?'off':'on';
              this.$message.error(res.msg)
            }
          })
        }).catch(() => {
          this.wechat_status = this.wechat_status === 'on'?'off':'on';
          this.$message({
            type:'info',
            message: '已取消'
          })
        })
      },
      editoptin(row) {
        this.form.id = row.id
        this.form.value = row.val
        this.optionVisible = true
      },
      submitform() {
        this.optionVisible = false
        setOption(this.form).then(res => {
          if(res.code == 0){
            this.getoption(this.formInline);
            this.$message({
              type: 'success',
              message: res.msg
            })
          }else{
            this.$message.error(res.msg)
          }
        })
      },
      submitpsw(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            editRefundPsw(this.ruleForm).then(res => {
              if(res.code == 0){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              }else{
                this.$message.error(res.msg)
              }
            })
            .catch( err => {
              this.$message.error('退出失败，请稍后再试！')
            })
          }
        })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.limit = parm.pageSize
        this.getdata(this.formInline)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/system/Variable.vue